"use client";
import ReactPlayer from "react-player/lazy";

import useHasHydrated from "@/lib/hooks/useHasHydrated";

import Skeleton from "../Skeleton";

const Video = (props: {
  url: string;
  [key: string]: unknown;
}): React.JSX.Element => {
  const hasHydrated = useHasHydrated();
  if (!props.url || !hasHydrated) return <Skeleton height="100%" />;
  return (
    <ReactPlayer
      {...props}
      playsinline
      autoPlay
      muted
      playing
      loop
      fallback={<Skeleton height="100%" />}
    />
  );
};

export default Video;
